export function isObject(value: any): boolean {
    return value !== null && typeof value === 'object';
}

export function pruneObjectKeys<T>(defaults: T, obj: any): T {
    if (!isObject(obj)) return defaults;

    if (Array.isArray(defaults)) {
        if (!Array.isArray(obj)) return defaults;

        const template = defaults[0];

        if (template && isObject(template)) {
            return obj.map((item) => pruneObjectKeys(template, item)) as unknown as T;
        }

        return obj as T;
    }

    const result: any = {};
    for (const key in defaults) {
        if (key in obj) {
            if (isObject(defaults[key])) {
                result[key] = pruneObjectKeys(defaults[key], obj[key]);
            } else {
                result[key] = obj[key];
            }
        } else {
            result[key] = defaults[key];
        }
    }

    return result;
}
